import React, { CSSProperties } from 'react';

interface FaceFrownProps {
    stroke?: string;
    fill?: string;
    secondaryFill?: string;
    width?: string;
    height?: string;
    style?: CSSProperties;
    className?: string;
}

const FaceFrown: React.FC<FaceFrownProps> = ({
    stroke = 'currentColor',
    fill = 'none',
    secondaryFill = 'currentColor',
    width = '100%',
    height = '100%',
    style,
    className
}) => {
    return (
        <svg
            height={height}
            width={width}
            viewBox="0 0 1060 1060"
            xmlns="http://www.w3.org/2000/svg"
            style={style}
            className={className}
        >
            <g fill={fill}>
                <defs />
                <circle
                    className="cls-1"
                    cx="530"
                    cy="530"
                    fill="none"
                    r="313"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="50px"
                />
                <ellipse
                    className="cls-2"
                    cx="436"
                    cy="447"
                    fill={secondaryFill}
                    rx="31.5"
                    ry="63"
                    strokeWidth="0px"
                />
                <ellipse
                    className="cls-2"
                    cx="624"
                    cy="447"
                    fill={secondaryFill}
                    rx="31.5"
                    ry="63"
                    strokeWidth="0px"
                />
                <path
                    className="cls-1"
                    d="M695 689.5s-54.56-110-165-110-165 110-165 110"
                    fill="none"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="50px"
                />
            </g>
        </svg>
    );
};

export default FaceFrown;